import { allow } from '../../classes/allow';
import translate from '../../functions/translate';
import useViewport from '../../hooks/use.viewport';
import is from '../../objects/is';
import the from '../../objects/the';
import Div from '../div';
import InputField from '../input.field';
import SuffixDropdown from '../suffix.dropdown';

interface LastNameSectionProps {
    onLastNameChange: (name: string) => void
    onLastNameBlur: () => void
    onSuffixChange: (suffix: string) => void
    errorMessage: string | null
    forceError: boolean
    inputRef: Function
    lastNameVal: string
    suffixVal: string
}

const LastNameSection = (props: LastNameSectionProps) => {
    const {width} = useViewport();

    const updateSuffix = (event: any) => {
        allow.anObject(event, is.not.empty);
        const suffix = event.target.value;
        props.onSuffixChange(suffix);
    };

    const onLastNameChange = (event: any) => {
        props.onLastNameChange(event.target.value);
    };

    return <>
        {width < the.minimumMediumViewportWidth &&
      <Div isRow={true}>
          <Div cols={12}>
              <InputField
                  aria-invalid={(!!props.errorMessage).toString()}
                  errorMessage={props.errorMessage}
                  inputRef={props.inputRef}
                  label={translate('Last name')}
                  name={translate('Last name')}
                  onBlur={props.onLastNameBlur}
                  onChange={onLastNameChange}
                  value={props.lastNameVal}
              />
          </Div>
          <Div cols={12}>
              <SuffixDropdown
                  onChange={updateSuffix}
                  value={props.suffixVal}
              />
          </Div>
      </Div>}

        {width > the.minimumMediumViewportWidth &&
      <Div isRow={true}>
          <Div cols={4}>
              <InputField
                  aria-invalid={(!!props.errorMessage).toString()}
                  errorMessage={props.errorMessage}
                  inputRef={props.inputRef}
                  label={translate('Last name')}
                  name={translate('Last name')}
                  onBlur={props.onLastNameBlur}
                  onChange={onLastNameChange}
                  value={props.lastNameVal}
              />
          </Div>
          <Div cols={2} paddingLeft={0}>
              <SuffixDropdown
                  onChange={updateSuffix}
                  value={props.suffixVal}
              />
          </Div>
      </Div>}
    </>
}

export default LastNameSection;